import { render, staticRenderFns } from "./database-form.vue?vue&type=template&id=f9b888a6"
import script from "./database-form.vue?vue&type=script&lang=js"
export * from "./database-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports